import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/global.css */
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  a {
    color: #fff;
    text-decoration: none;
    text-decoration-color: rgba(255, 255, 255, 0.4);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  a:hover {
    text-decoration: none;
  }
  button {
    outline: none;
    border: none;
    background: linear-gradient(
      180deg,
      #2159d1,
      #2159d0,
      #2158cf,
      #2057cd,
      #2056ca,
      #1f55c7,
      #1f53c3,
      #1e52c0,
      #1e51bd,
      #1d50bb,
      #1d4fba,
      #1d4fb9
    );
    text-decoration: none;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 100%;
    border-radius: 10px;
  }
  button:hover {
    background: linear-gradient(
      180deg,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf,
      #2058cf
    );
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsla(0, 0%, 100%, 0.5);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/wallet_menu.css */
  .balances_wrapper {
    cursor: pointer;
    display: flex;
    font-weight: 500;
    align-items: center;
    flex-direction: row;
    white-space: nowrap;
    position: relative;
    padding: 21px 10px 21px 34px;
    border-radius: 10px;
    height: 70px;
  }
  .balances_wrapper:before {
    position: absolute;
    content: '';
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    width: 18px;
    height: 18px;
    -webkit-mask: url(${icons.wallet_icon}) left center / auto 18px no-repeat;
    background: hsla(221, 73%, 47%);
  }
  .balances_wrapper .balances {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .balances_wrapper .available_balance {
    font-size: 0.65rem;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .balances_wrapper .net_balance {
    font-size: 0.85rem;
    position: relative;
    font-weight: 600;
    padding: 1px 0 0 0;
  }
  .balances_wrapper .info_icon {
    background: hsla(0, 0%, 100%, 0.2) url(${icons.info_icon}) center center / auto 7px no-repeat;
    margin: -2px 0 0 5px;
    border-radius: 4px;
    width: 12px;
    height: 13px;
    padding: 0;
    cursor: pointer;
  }
  .balances_wrapper button.deposit_button {
    padding: 8px 18px;
    line-height: 100%;
    border-radius: 10px;
    font-size: 0.75rem;
    margin: 0 0 0 10px;
    position: relative;
    height: fit-content;
    display: flex;
  }
`

const developerCSS = css`
  .balances_wrapper div.deposit_button {
    outline: none;
    border: none;
    background: var(--primary-button-background);
    text-decoration: none;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 100%;
    border-radius: 10px;
  }
  .balances_wrapper div.deposit_button:hover {
    background: var(--primary-button-hover-background);
    color: #fff;
  }
  .balances_wrapper div.deposit_button {
    padding: 8px 18px;
    line-height: 100%;
    border-radius: 10px;
    font-size: 0.75rem;
    margin: 0 0 0 10px;
    position: relative;
    height: fit-content;
    display: flex;
  }
  .balances_wrapper {
    padding: 21px 10px 21px 34px;
    height: 50px;
  }
  .balances_wrapper:hover {
    background: var(--tab-hover-background);
  }
`

export const HeaderWalletCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
